import { render, staticRenderFns } from "./BlocoCertificacaoTerritorio.vue?vue&type=template&id=5f6f0bde&scoped=true"
import script from "./BlocoCertificacaoTerritorio.vue?vue&type=script&lang=js"
export * from "./BlocoCertificacaoTerritorio.vue?vue&type=script&lang=js"
import style0 from "./BlocoCertificacaoTerritorio.vue?vue&type=style&index=0&id=5f6f0bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f0bde",
  null
  
)

export default component.exports